import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { getMembershipIntegrationStatus, getMembershipKey, isOrganizableConferenceLocation, Location } from 'components/event_type_edit';
import { useToggleState } from 'hooks/useToggleState';
import { AccordionPanel } from '../../../../components/accordion';
import { getLocationKindLabel } from '../utils';
import { ReadonlyHosts } from './read_only_host';
const styledAccordionCss = "sojmeys";
const StyledAccordion = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledAccordionCss, props.className)} />;
});
const locationSummaryContainerCss = "l1syo6lt";
const LocationSummaryContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(locationSummaryContainerCss, props.className)} />;
});
const locationTipDangerCss = "ltz16tw";
const locationTipCss = "l15ic8d3";
const LocationTip = forwardRef((props, ref) => {
  const {
    danger,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(locationTipCss, {
    [locationTipDangerCss]: danger
  }, props.className)} />;
});
const IntegrationError = ({
  kind
}) => <LocationSummaryContainer>
    <LocationTip danger>
      <AlertWarningTriangleIcon />
      {I18n.t('publisher.event_type_editor.sections.event_details.location.connection_error', {
      kind
    })}
    </LocationTip>
  </LocationSummaryContainer>;
const HostPanel = ({
  eventType,
  isManaged,
  isSelectedForAllHosts,
  setIsSelectedForAllHosts,
  isCollectiveRoundRobin,
  userPools,
  membership,
  membershipIndex,
  isReadOnly
}) => {
  const locationKind = membership.locationConfiguration?._destroy ? null : membership.locationConfiguration?.kind;
  const locationKindLabel = getLocationKindLabel(locationKind);
  const [_, {
    error
  }] = useFormField({
    name: `memberships[${membershipIndex}]`
  });
  const [isPanelOpen, togglePanel] = useToggleState(Boolean(error));
  const [startExpanded, setStartExpanded] = useState(true);
  if (!membership.enabled) return null;
  if (isCollectiveRoundRobin && membership.user_pool_uid !== (userPools[0]?.uuid || userPools[0]?.key)) return null;
  const integrationError = isOrganizableConferenceLocation(locationKind) && getMembershipIntegrationStatus(membership, locationKind);
  const handleSelected = (__, isOpen) => {
    togglePanel();
    setTimeout(() => setStartExpanded(!isOpen), 300);
  };
  return <AccordionPanel useAlternateStyle key={getMembershipKey(membership)} panelKey={`${getMembershipKey(membership)}-location`} expand={isPanelOpen} onSelected={handleSelected} title={membership.name} sidebar={<FullStoryExclude>
          <Avatar size="small" src={membership.avatar_url} letter={membership.avatar_letter} alt={membership.name} />
        </FullStoryExclude>} subheader={integrationError ? <IntegrationError kind={locationKindLabel} /> : locationKindLabel}>
      <Location key={getMembershipKey(membership)} eventType={eventType} membership={membership} isManaged={isManaged} isSelectedForAllHosts={isSelectedForAllHosts} setIsSelectedForAllHosts={setIsSelectedForAllHosts} startExpanded={startExpanded} isReadOnly={isReadOnly} />
    </AccordionPanel>;
};
export const AllHostsList = ({
  eventType,
  memberships,
  isManaged,
  isSelectedForAllHosts,
  setIsSelectedForAllHosts,
  isCollectiveRoundRobin,
  userPools,
  isReadOnly
}) => isReadOnly ? memberships.map(membership => <ReadonlyHosts key={getMembershipKey(membership)} membership={membership} />) : <StyledAccordion>
      {memberships.map((membership, index) => <HostPanel key={getMembershipKey(membership)} eventType={eventType} isManaged={isManaged} isSelectedForAllHosts={isSelectedForAllHosts} setIsSelectedForAllHosts={setIsSelectedForAllHosts} isCollectiveRoundRobin={isCollectiveRoundRobin} userPools={userPools} membership={membership} membershipIndex={index} isReadOnly={isReadOnly} />)}
    </StyledAccordion>;

require("./all_hosts_list.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./all_hosts_list.js");